<section id="comments" class="assignment-comments">
  @if (commentFormModel && commentFormModel.form; as commentsForm) {
    <form [formGroup]="commentsForm" class="assignment-comments__form">
      @if (!isReadonly) {
        <section class="assignment-comments__composer" formGroupName="newComment">
          <div class="assignment-create-editor form-input assignment-comments__editor-shell">
            <app-custom-quill-editor
              [placeholder]="'PLACEHOLDERS.COMMENT' | translate"
              id="new-comment"
              formControlName="message"
            />
          </div>

          <div class="assignment-comments__composer-actions">
            <button
              type="button"
              class="form-primary-btn assignment-comments__submit"
              [disabled]="commentsForm.controls.newComment.invalid"
              (click)="addComment()"
            >
              {{ "BUTTONS.ADD_COMMENT" | translate }}
            </button>
          </div>
        </section>
      }

      <div class="assignment-comments__list" formArrayName="groupedComments">
        @for (commentsGroup of groupedCommentEntries$ | async; track commentsGroup.dateKey; let groupIndex = $index) {
          <section class="assignment-comments__group" [formGroupName]="groupIndex">
            <div class="assignment-comments__group-list" formArrayName="comments">
              @for (comment of commentsGroup.comments; track comment.id; let commentIndex = $index) {
                <div class="assignment-comments__entry">
                  <article class="assignment-comments__item" [formGroupName]="commentIndex">
                    <div class="assignment-comments__item-header">
                      <app-minimal-profile-info
                        class="assignment-comments__profile"
                        [profile]="comment.user"
                        [fullNameClass]="'fw-bolder'"
                        imageHeight="40px"
                        imageWidth="40px"
                        [collapseDetailsOnMobile]="false"
                      />

                      @if (editingCommentId === comment.id) {
                        <div class="assignment-comments__actions">
                          <button
                            type="button"
                            class="assignment-comments__action-btn assignment-comments__action-btn--save"
                            [ngbTooltip]="'TOOLTIPS.SAVE_CHANGES' | translate"
                            [disabled]="
                              commentFormModel.form.controls.groupedComments
                                .at(groupIndex)
                                .controls.comments.at(commentIndex).invalid
                            "
                            (click)="saveComment(groupIndex, commentIndex)"
                          >
                            <svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5.5 11.2L0.8 6.5L2.2 5.1L5.5 8.4L13.8 0.1L15.2 1.5L5.5 11.2Z" fill="currentColor"/>
                            </svg>
                          </button>
                          <button
                            type="button"
                            class="assignment-comments__action-btn assignment-comments__action-btn--cancel"
                            [ngbTooltip]="'TOOLTIPS.CANCEL_CHANGES' | translate"
                            (click)="cancelEditing(groupIndex, commentIndex)"
                          >
                            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12.7 4.7L11.3 3.3L8 6.6L4.7 3.3L3.3 4.7L6.6 8L3.3 11.3L4.7 12.7L8 9.4L11.3 12.7L12.7 11.3L9.4 8L12.7 4.7Z" fill="currentColor"/>
                            </svg>
                          </button>
                        </div>
                      } @else if (comment.editable && !isReadonly) {
                        <div class="assignment-comments__actions">
                          <div class="assignment-comments__dropdown" ngbDropdown placement="bottom-end" container="body">
                            <button
                              type="button"
                              class="assignment-comments__action-btn assignment-comments__action-btn--menu"
                              ngbDropdownToggle
                              [attr.aria-label]="'BUTTONS.ACTIONS' | translate"
                            >
                              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 4.25C10.9665 4.25 11.75 3.4665 11.75 2.5C11.75 1.5335 10.9665 0.75 10 0.75C9.0335 0.75 8.25 1.5335 8.25 2.5C8.25 3.4665 9.0335 4.25 10 4.25Z" fill="currentColor"/>
                                <path d="M10 11.75C10.9665 11.75 11.75 10.9665 11.75 10C11.75 9.0335 10.9665 8.25 10 8.25C9.0335 8.25 8.25 9.0335 8.25 10C8.25 10.9665 9.0335 11.75 10 11.75Z" fill="currentColor"/>
                                <path d="M10 19.25C10.9665 19.25 11.75 18.4665 11.75 17.5C11.75 16.5335 10.9665 15.75 10 15.75C9.0335 15.75 8.25 16.5335 8.25 17.5C8.25 18.4665 9.0335 19.25 10 19.25Z" fill="currentColor"/>
                              </svg>
                            </button>

                            <div class="assignment-comments__dropdown-menu project-actions-menu assignment-comments-actions-menu" ngbDropdownMenu>
                              <button
                                type="button"
                                class="assignment-comments__dropdown-item project-actions-menu-item"
                                ngbDropdownItem
                                (click)="editComment(comment.id)"
                              >
                                {{ "BUTTONS.EDIT" | translate }}
                              </button>
                              <div class="project-actions-menu-divider"></div>
                              <button
                                type="button"
                                class="assignment-comments__dropdown-item assignment-comments__dropdown-item--danger project-actions-menu-item project-actions-menu-item-danger"
                                ngbDropdownItem
                                (click)="deleteComment(comment.id)"
                              >
                                {{ "BUTTONS.REMOVE" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      }
                    </div>

                    @if (editingCommentId === comment.id) {
                      <div class="assignment-create-editor form-input assignment-comments__editor-shell">
                        <app-custom-quill-editor
                          [placeholder]="'PLACEHOLDERS.COMMENT' | translate"
                          formControlName="message"
                        />
                      </div>
                    } @else {
                      <div class="assignment-comments__message-wrap">
                        <div class="assignment-comments__message" [innerHTML]="comment.sanitizedMessage"></div>
                      </div>
                    }
                  </article>
                  <p class="assignment-comments__posted-at">{{ comment.displayCreatedAt }}</p>
                </div>
              }
            </div>
          </section>
        }
      </div>
    </form>
  }
</section>
